import { render, staticRenderFns } from "./driver_mng_page.vue?vue&type=template&id=22fb0f90"
import script from "./driver_mng_page.vue?vue&type=script&lang=js"
export * from "./driver_mng_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fb0f90')) {
      api.createRecord('22fb0f90', component.options)
    } else {
      api.reload('22fb0f90', component.options)
    }
    module.hot.accept("./driver_mng_page.vue?vue&type=template&id=22fb0f90", function () {
      api.rerender('22fb0f90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/driver/driver_mng_page.vue"
export default component.exports